import useBottomSheetStore from 'stores/bottomSheetStore';

/**
 * BottomSheet 커스텀 훅
 * 컴포넌트 내부에서 BottomSheet 상태를 관리할 때 사용
 */
const useBottomSheet = () => {
  const { open, close, sheets, setStatus, updateOptions, updateData } = useBottomSheetStore();

  const getSheet = (id: string) => {
    return sheets[id];
  };

  return {
    open,
    close,
    sheets,
    getSheet,
    setStatus,
    updateOptions,
    updateData,
  };
};

export default useBottomSheet;
